import { ThemeEvents } from '@theme/events';
const { dialogClose, dialogOpen, cartCount, cartUpdate, currencyUpdate, cartReload, progressBarChange } = ThemeEvents;

const originalFetch = window.fetch;

function getCartDrawerSectionId() {
  return document.querySelector('hdt-cart-drawer[section-id]')?.getAttribute('section-id') || null;
}

function getMainCartSectionId() {
  const mainCartEl = document.querySelector('[id^="shopify-section-template--"][id$="__main-cart"]');
  if (!mainCartEl?.id) return null;
  return mainCartEl.id.replace('shopify-section-', '');
}

function getCartSectionIds() {
  return [getCartDrawerSectionId(), getMainCartSectionId()].filter(Boolean);
}

function injectSectionsIntoBody(init, sectionIds) {
  if (!init) return init;
  const nextInit = { ...init };
  const body = nextInit.body;
  const sectionsValue = sectionIds.join(',');

  if (body instanceof FormData) {
    if (!body.has('sections')) body.append('sections', sectionsValue);
    nextInit.body = body;
    return nextInit;
  }

  if (body instanceof URLSearchParams) {
    if (!body.has('sections')) body.append('sections', sectionsValue);
    nextInit.body = body;
    return nextInit;
  }

  try {
    const parsed = JSON.parse(body || '{}');
    if (!parsed.sections) {
      parsed.sections = sectionIds;
      nextInit.body = JSON.stringify(parsed);
      return nextInit;
    }
  } catch (e) {  }
  return nextInit;
}

function getSectionShortName(sectionId) {
  if (!sectionId) return null;
  const match = sectionId.match(/__(.+)$/);
  return match ? match[1] : sectionId;
}

function pickSectionHtml(sections, sectionId) {
  if (!sections) return null;
  const shortName = getSectionShortName(sectionId);
  return sections[sectionId] || (shortName && sections[shortName]) || null;
}

function parseSectionHtml(sectionHtml) {
  if (!sectionHtml) return null;
  const temp = document.createElement('div');
  temp.innerHTML = sectionHtml.trim();
  return temp;
}

const SYNC_ATTRS = ['data-count', 'data-total-price'];

function syncAttrs(target, source, attrs) {
  if (!target || !source) return;
  attrs.forEach((attr) => {
    const v = source.getAttribute(attr);
    if (v != null) target.setAttribute(attr, v);
  });
}

window.fetch = function(...args) {
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  const isCartMutation = /\/cart\/(add|change|update)(\.js)?/.test(url);

  if (isCartMutation) {
    const sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      args[1] = injectSectionsIntoBody(args[1], sectionIds);
    }
  }

  return originalFetch.apply(this, args).then(res => {
    if (url.includes('/cart/add')) {
      res.clone().json().then(data => {
        const sectionId = getCartDrawerSectionId();
        const sectionHtml = pickSectionHtml(data.sections, sectionId);
        document.dispatchEvent(new CustomEvent('ethan:cart:updated', {
          bubbles: true,
          detail: { cart: data, sectionHtml, sectionId }
        }));
      }).catch(() => {});
    }
    return res;
  });
};
class cartPopup extends HTMLElement {
  constructor() {
    super();
    this.cartIcon = document.querySelector('ethan-cart-icon');
    this._isSyncing = false;
    this._inited = false;
    this.sectionID = this.getAttribute('section-id');

    this._onCartUpdated = (e) => {
      console.log("cart updated", e);
      
      this.syncAfterAtc(e);
    };
    this._onMouseEnter = () => this.classList.add('current_hover');
    this._onMouseLeave = () => this.classList.remove('current_hover');
  }

  connectedCallback() {
    this.init();
    document.addEventListener('ethan:cart:updated', this._onCartUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('ethan:cart:updated', this._onCartUpdated);
    this.removeEventListener('mouseenter', this._onMouseEnter);
    this.removeEventListener('mouseleave', this._onMouseLeave);
    this._inited = false;
  }

  init() {
    if (this._inited) return;
    if (!this.cartIcon) return;

    document.body.style.setProperty('--ethan-cart-w', this.getBoundingClientRect().width + 'px');
    document.body.style.setProperty('--ethan-cart-left', this.cartIcon.getBoundingClientRect().right + 'px');
    document.body.style.setProperty('--ethan-cart-top', '45px');

    this.addEventListener('mouseenter', this._onMouseEnter);
    this.addEventListener('mouseleave', this._onMouseLeave);
    this._inited = true;
  }

  async syncAfterAtc(event) {
    let { cart, sectionHtml, sectionId } = event.detail;
    if (this._isSyncing) return;
    this._isSyncing = true;
    try {
      

      if (sectionId && sectionHtml) {
        const wrapper = document.querySelector(`#shopify-section-${sectionId}`);
        const parsed = parseSectionHtml(sectionHtml);
        const currentDrawer = wrapper?.querySelector('hdt-cart-drawer');
        const newDrawer = parsed?.querySelector('hdt-cart-drawer');
        const currentInner = currentDrawer?.querySelector('.hdt-dialog-drawer__inner');
        const newInner = newDrawer?.querySelector('.hdt-dialog-drawer__inner');
        const item_count = parsed?.querySelector('[ref="hdt-cart"]')?.getAttribute('data-count');

        document.dispatchEvent(new CustomEvent(cartCount, {
          detail: { item_count: item_count }
        }));
        if (currentInner && newInner) {
          syncAttrs(currentDrawer, newDrawer, SYNC_ATTRS);
          currentInner.replaceChildren(...newInner.childNodes);
          await new Promise((r) => requestAnimationFrame(r));
          const popup = currentDrawer.querySelector('ethan-cart-popup');
          if (popup) popup.classList.add('current_hover');
          return;
        }
      }

      document.dispatchEvent(new CustomEvent(cartReload, { bubbles: true }));
      await this.waitForCartReloadDone();

      await new Promise((r) => requestAnimationFrame(r));
      this.classList.add('current_hover');
      
    } catch (err) {
      console.error('[cartPopup] syncAfterAtc error', err);
    } finally {
      this._isSyncing = false;
    }
  }

  waitForCartReloadDone() {
    return new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        cleanup();
        requestAnimationFrame(resolve);
      };
      const cleanup = () => {
        document.removeEventListener('theme:loading:done', finish);
        clearTimeout(timer);
      };
      document.addEventListener('theme:loading:done', finish, { once: true });
      const timer = setTimeout(finish, 1200);
    });
  }
}
customElements.define('ethan-cart-popup', cartPopup);

